export default {
  source: {
    url: "mapbox://mepa1363.69s1ymgf"
  },
  layer: {
    id: "accessibility-schools",
    source: "pickyourplace_schools",
    minZoom: 5,
    maxZoom: 22,
    color: "#edf8b1",
    icon: "school-15",
    text: "name"
  }
};
